import type { HtmlAttributes, HtmlAttributesWithChildren } from '@studio/design-system/props';
import type { ReactElement } from 'react';
import { twMerge } from 'cn';
import { Columns as _Columns } from '#~/common/editor/index.js';

/** `<Columns>` component. */
export const Columns = ({
  children,
  className,
  ...props
}: HtmlAttributesWithChildren): ReactElement => (
  <_Columns className={twMerge('grid-cols-[repeat(2,350px)] gap-[80px]', className)} {...props}>
    {children}
  </_Columns>
);

/** Column. */
Columns.Column = _Columns.Column;

/** Horizontal rule. */
export const HRule = ({ className, ...props }: HtmlAttributes): ReactElement => (
  <hr className={twMerge('my-32', className)} {...props} />
);
